import { createContext } from 'react';
import {
  IOTP, IRecoverPassword, IRecoveryForm, IPasswordForm,
  IPasswordVisibilityOption, FORM_STEP, IHistory,
} from '../constant';

export const RecoverPasswordContext = createContext({
  modalCollection: new Map(),
  setModalCollection: () => {},

  formStep: FORM_STEP.STEP_1,
  setFormStep: () => {},

  recoverForm: IRecoveryForm(),
  setRecoverForm: () => {},

  passwordForm: IPasswordForm(),
  setPasswordForm: () => {},

  visibilityOption: IPasswordVisibilityOption(),
  setVisibilityOption: () => {},

  otp: IOTP(),
  setOTP: () => {},

  otpExpiryTime: { current: 0 },

  recoverPassword: IRecoverPassword(),

  history: IHistory(),

  handler: {
    handleModalOpen: ({ key = '', modal = {} }) => {},
    handleModalClose: ({ key = '' }) => {},
    handleMultipleModalClose: ({ keys = [] }) => {},
    handleSendOTP: async () => {},
  },

  action: {
    sendOTP: async (data = {}) => ({}),
    validateOTP: async (data = {}) => ({}),
    recoverPassword: async (data = {}) => ({}),
    clearRecoverPassword: (data = {}) => {},
  },
});

export const RecoverPasswordProvider = RecoverPasswordContext.Provider;
